import React from 'react';

import './ChatRoomList.scss';
import BackButton from '../BackButton/BackButton.jsx';
import icons from '../../shared/assets/icons/redesign';

const { ChatInfo } = icons;

export default function ChatRoomList(
  { list, provider, providerRoomId }
) {
  return (
    <div className="chatRoomList">
      <BackButton path="/dashboard" />

      <div className="chatRoomList-header">
        <h4 className="chatRoomList-header-title">Chat</h4>

        {provider?.chatFeature &&
          <a
            href={providerRoomId
              ? `/rooms/${providerRoomId}`
              : `/create-room/${provider.accountName}`}
            className="chatRoomList-start-chat-button"
          >
            &#x2B;
          </a>
        }
      </div>

      <p className="chatRoomList-message">
        <ChatInfo className="chatRoomList-message-icon" />
          Deze functie is niet bedoeld voor spoedmeldingen en wordt niet
          direct beantwoord. Neem hiervoor, telefonisch, contact op met
          jouw zorgverlener.
      </p>

      {list.length ?
        <ul className="chatRoomList-list">
          {list.map(room =>
            <li key={room.identifier} className="chatRoomList-item">
              <img
                alt="organization-logo"
                src={room.logoUrl}
                className="chatRoomList-item-image"
              />

              <p className="chatRoomList-item-text">
                {room.displayName}
              </p>

              <a
                href={`/rooms/${room.identifier}`}
                className="chatRoomList-item-button"
              >
                <span className="chat-indicator" />
                Starten
              </a>
            </li>
          )}
        </ul> :
        <p className="chatRoomList-text">
          Op dit moment zijn er geen actieve chats
        </p>
      }
    </div>
  );
}
